<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'SHARED.TOOLBAR_AMORTIZATION_SCHEDULE_LABEL' | translate }}</h3>
    </div>
    <div class="sp-row__align">
      <div
        class="sp-order__status-radius sp-row__center sp-padding__left sp-padding__right sp-background__primary-contrast">
        <span class="sp-text__ellipsized sp-text__center">{{ steps?.length || 0 }}</span>
      </div>
    </div>
  </div>
  <div *ngFor="let step of getSortedSteps()">
    <div
      *ngIf="steps?.length"
      class="sp-background__primary-contrast sp-margin sp-margin__top-x2 sp-border-radius sp-padding__x2">
      <div class="sp-margin__left sp-margin__right">
        <div class="sp-row__space">
          <div class="sp-row__align">
            <span class="sp-color__accent">{{ 'STEPS.STEP_LABEL' | translate }} {{ step?.index ?? 0 }}</span>
            <span class="sp-color__accent sp-margin__left sp-margin__right"> - </span>
            <app-shared-id
              [content]="step?.step_id || '-'"
              [content_class]="'sp-color__accent'"
              [is_shrinked_id]="true"></app-shared-id>
          </div>
          <div class="sp-padding__horiz-x2 sp-padding__vert sp-row__align">
            <div>
              <button
                (click)="onQineticReloadClick(step)"
                [disabled]="step.status && ![completed_step_status].includes(step.status)"
                mat-icon-button
                class="sp-icon__button sp-icon__button-accent"
                [matTooltip]="'ORDERS.QINETIC_RETRY_CTA' | translate">
                <mat-icon class="material-symbols-outlined"> reply </mat-icon>
              </button>
              <button
                (click)="onRequestsClick(step)"
                mat-icon-button
                class="sp-icon__button sp-icon__button-accent sp-margin__left"
                [matTooltip]="'GENERAL.SEE_REQUESTS_CTA' | translate">
                <mat-icon class="material-symbols-outlined"> list </mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="sp-row__space">
          <div class="sp-row__align">
            <span
              >{{ (step.amount?.total || 0) / 100 | number : '0.2-2' }}{{ getCurrencyLabel(step) }} -
              {{ step.due_date | date : 'dd/MM/yyyy' }}</span
            >
          </div>
          <div class="sp-row__align">
            <div
              [ngClass]="getStepStatusClass(step.status)"
              class="sp-order__status-radius sp-row__center sp-padding__horiz sp-width__fit-content">
              <span class="sp-text__ellipsized sp-text__center">{{
                getStepStatusLabel(step.status) | translate | lowercase
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
